/**
 * Module-level cache of the currently bootstrapped spreadsheet id.
 *
 * Lives outside `App.tsx` so non-shell modules (Settings, share UI) can
 * read it without importing App (which would create a circular dependency).
 *
 * - Set by `App.tsx` after `bootstrapWithMeta` resolves.
 * - Cleared by logout (and the dev-mode reset path).
 * - Stored here (not in zustand) so the `persist` middleware never serialises
 *   it — the id is per-account-per-bootstrap and must not survive a logout.
 */

let cachedId: string | null = null;

export function getActiveSpreadsheetId(): string | null {
  return cachedId;
}

export function setActiveSpreadsheetId(id: string | null): void {
  cachedId = id;
}
